import { handleActions } from 'redux-actions'
import { resetFormFilters, setFormFilter } from './actions'

export const initialState = {
    property: {
        propertyServiceId: null,
        propertyTypeId: null,
        propertyStatusId: null,
        propertyMainRegisterId: null,
        propertyRegistryDepartmentKpuId: null
    },
    contactProfile: {
        propertyServiceId: null,
        propertyTypeId: null,
    },
    location: {
        country: null,
        county: null,
        city: null,
        widerArea: null,
        quarter: null,
        island: null,
    },
}

export default handleActions(
    {
        [setFormFilter]: (state, { payload }) => {
            const { context, field, value } = payload

            // Handle location filters
            if (context === 'location') {
                return {
                    ...state,
                    location: {
                        ...state.location,
                        [field]: value,
                    },
                }
            }

            // Handle property and contactProfile filters
            return {
                ...state,
                [context]: {
                    ...state[context],
                    [field]: value,
                },
            }
        },
        [resetFormFilters]: (state, { payload }) => {
            const { context } = payload || {}

            if (!context) {
                return initialState
            }

            // Reset specific context
            return {
                ...state,
                [context]: initialState[context],
            }
        },
    },
    initialState
)
